export class ModeloIndicador  {
    public codigoModelo?: string
    public codigoNCM?: string
    public codigoDestaque?: string
    public descricaoDestaque?: string
    public corModelo?: string
    public nomeModeloResumido?: string;
}
